var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "528.000000pt",
    viewBox: "0 0 512.000000 528.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,528.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1102 5255 c-166 -57 -301 -143 -438 -279 -172 -173 -270 -355 -319 -591 -110 -539 184 -1087 697 -1299 137 -57 234 -77 398 -83 165 -6 263 8 414 58 340 113 615 390 730 734 80 238 75 524 -14 767 -117 321 -386 583 -714 694 -67 23 -80 24 -375 24 -299 -1 -308 -1 -379 -25z m633 -219 c425 -127 701 -533 655 -964 -33 -316 -205 -573 -482 -721 -584 -312 -1305 98 -1335 759 -12 264 67 482 244 669 124 132 262 217 425 260 109 29 112 30 263 26 117 -2 155 -7 230 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 4871 c-62 -39 -63 -45 -63 -413 0 -307 2 -335 19 -361 41 -63 28 -61 451 -62 361 0 387 1 413 19 76 52 75 164 -3 210 -24 14 -68 16 -329 16 l-301 0 0 238 c0 130 -5 253 -10 273 -22 80 -112 121 -177 80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2760 4504 c0 -3 9 -49 19 -102 11 -54 22 -134 26 -179 l7 -83 622 0 c598 0 622 -1 653 -20 68 -41 63 98 63 -1767 0 -1657 0 -1689 -20 -1720 -41 -67 41 -63 -1230 -63 -1048 0 -1154 1 -1180 16 -64 38 -60 -39 -60 1163 l0 1091 -124 -1 c-69 0 -152 3 -185 7 l-61 7 0 -1114 c0 -1063 1 -1117 19 -1179 50 -172 182 -299 358 -345 87 -23 2376 -22 2473 1 129 30 258 128 318 243 66 124 62 12 62 1897 0 1866 3 1759 -56 1882 -34 69 -117 158 -188 201 -118 71 -122 71 -858 71 -362 0 -658 -3 -658 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2225 3030 c-34 -14 -76 -65 -81 -101 -7 -45 22 -97 67 -121 32 -17 70 -18 737 -16 l704 3 34 37 c42 46 47 102 13 150 -43 59 -25 58 -771 57 -376 0 -692 -4 -703 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2212 2273 c-60 -30 -84 -119 -45 -172 11 -14 35 -34 54 -44 32 -16 82 -17 724 -15 641 3 693 4 718 21 39 26 59 62 59 107 -1 45 -18 74 -59 101 -27 18 -63 19 -723 19 -622 0 -698 -2 -728 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2209 1495 c-39 -21 -59 -59 -59 -109 0 -39 5 -51 35 -81 l36 -35 714 0 714 0 36 35 c44 45 51 101 18 152 -36 54 -15 53 -770 53 -583 -1 -702 -3 -724 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.80611e69b61c939b07c340caf1a3e047.svg";
export { ForwardRef as ReactComponent };